import React, { PureComponent } from "react";
import { connect } from "react-redux";
class Music extends PureComponent {
  componentDidMount() {
    const that = this;
    window.audioBg = document.getElementById("bgAudio");
    window.audioBtn = document.getElementById("btnAudio");
    window.PlayAudio = function() {
      console.log("放音乐");
      audioBg.load();
      audioBg.play(); // iOS 7/8 仅需要 play 一下
    };
    // // 触摸屏幕
    // document.addEventListener("touchend", PlayAudio, false);
    // audioBg.addEventListener(
    //   "play",
    //   function() {
    //     document.removeEventListener("touchend", PlayAudio, false);
    //   },
    //   false
    // );
    // PlayAudio();
    audioBg.addEventListener(
      "canplay",
      function() {
        console.log("audio canplay");
      },
      false
    );
    audioBg.addEventListener(
      "canplaythrough",
      function() {
        console.log("audio canplaythrough");
      },
      false
    );
    audioBg.addEventListener(
      "play",
      function() {
        console.log("audio play");
      },
      false
    );
    audioBg.addEventListener(
      "pause",
      function() {
        console.log("audio pause");
      },
      false
    );
  }
  componentDidUpdate(preDate) {
    if (preDate.pageTag != this.props.pageTag) {
      if (this.props.pageTag == "result") {
        myVideo.pause();
        document.addEventListener("touchend", PlayAudio, false);
        audioBg.addEventListener(
          "play",
          function() {
            document.removeEventListener("touchend", PlayAudio, false);
          },
          false
        );
        PlayAudio();
      } else {
        document.removeEventListener("touchend", PlayAudio, false);
        audioBg.pause();
        myVideo.play();
      }
    }
  }
  render() {
    return (
      <div>
        {/* <audio
          preload="true"
          src={require("@assets/audio/audio_bg.mp3")}
          id="bgAudio"
        ></audio>
        <audio
          preload="true"
          src={require("@assets/audio/audio_btn.mp3")}
          id="btnAudio"
        ></audio> */}
        {/* 控制音乐 */}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(Music);
